module.exports = require("signature_pad");